import { createSelector } from '@reduxjs/toolkit';
import { RootState } from './store';

export const selectApp = (state: RootState) => state.app;
export const selectSidebarSize = createSelector(selectApp, (app) => app.sidebarSize);
export const selectActiveView = createSelector(selectApp, (app) => app.activeView);
export const selectAlerts = createSelector(selectApp, (app) => app.alerts);
export const selectAlertSeenTime = createSelector(selectApp, (app) => app.alertSeenTime);
